var getTaskFlowTheme = theme => {
  return {
    colors: {
      headerProgressBar: {
        initial: theme.colors.oranges[50]
      },
      stepTickIcon: {
        initial: theme.colors.greens[70]
      },
      stepHighlight: {
        initial: theme.colors.reds[50]
      },
      stepIndicator: {
        initial: theme.colors.greys[20]
      },
      navigationArrowIcon: {
        initial: theme.colors.greys[30],
        active: theme.colors.oranges[50]
      },
      navigationTickIcon: {
        initial: theme.colors.greens[70]
      },
      navigationHighlight: {
        initial: theme.colors.reds[50]
      }
    }
  };
};
export { getTaskFlowTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
